/**
 * Geofence types — shared across backend (`backend-tms/src/geofences/`)
 * and frontend (`apps/web-tms/src/components/maps/geofence-layer.tsx`).
 *
 * Single source of truth prevents string drift when categories or
 * shape types are added on one side but not the other.
 */

export enum GeofenceType {
  POLYGON = 'polygon',
  CIRCLE = 'circle',
}

export enum GeofenceCategory {
  DELIVERY = 'delivery',
  RESTRICTED = 'restricted',
  WAREHOUSE = 'warehouse',
  PARKING = 'parking',
  CUSTOM = 'custom',
}

export type GeofenceEventType = 'enter' | 'exit';

export interface GeofencePoint {
  lat: number;
  lng: number;
}

/**
 * Wire shape for `geofence.violation` (EventEmitter) and
 * `geofence:violation` (WebSocket) — same payload on both transports.
 */
export interface GeofenceViolationEvent {
  geofenceId: string;
  geofenceName: string;
  shipmentId: string;
  tenantId: string;
  eventType: GeofenceEventType;
  location: GeofencePoint;
  timestamp: string;
}
